import { CookiesProvider } from 'react-cookie'
import { BrowserRouter } from 'react-router-dom'
import { AdminToolWrapperProps, IntlWrapper } from '../components'
import { LocalizationsUpdater } from '../components/localization'
import {
  AuthInfoProvider,
  ClientThemeProvider,
  ConfigProvider,
  IsMobileProvider
} from '../contexts'

export const AppWrapper = ({
  children,
  useAdminTool,
  useAdminToolNews
}: AdminToolWrapperProps) => {
  return (
    <ConfigProvider>
      <BrowserRouter>
        <ClientThemeProvider>
          <IntlWrapper useAdminTool={useAdminTool}>
            <AuthInfoProvider>
              <IsMobileProvider>
                <CookiesProvider>
                  <LocalizationsUpdater
                    useAdminTool={useAdminTool}
                    useAdminToolNews={useAdminToolNews}
                  />
                  {children}
                </CookiesProvider>
              </IsMobileProvider>
            </AuthInfoProvider>
          </IntlWrapper>
        </ClientThemeProvider>
      </BrowserRouter>
    </ConfigProvider>
  )
}
